import React, { useEffect, useState } from 'react';
import { Button } from 'components/ui/button';
import { faBookmark } from '@fortawesome/pro-solid-svg-icons';
import { faBookmark as farBookmark } from '@fortawesome/pro-regular-svg-icons';
import { updateConnectProperty } from '../../../../helpers/prospect_api';

type PropertyBookmarkProps = {
  bookmarked: boolean;
  buttonClass?: string;
  id: string;
  size?: React.ComponentProps<typeof Button>['size'];
}

export default function PropertyBookmark({ id, bookmarked, buttonClass, size }: PropertyBookmarkProps) {
  const [isBookmarked, setIsBookmarked] = useState(bookmarked);

  useEffect(() => {
    const handlePropertyBookmarked = (e: CustomEvent<{ id: string }>) => {
      if (e.detail.id == id) {
        updateConnectProperty(id, { bookmarked: !isBookmarked }).then(() => setIsBookmarked(!isBookmarked));
      }
    };

    window.addEventListener('propertyBookmark', handlePropertyBookmarked);

    return () => {
      window.removeEventListener('propertyBookmark', handlePropertyBookmarked);
    };
  }, [isBookmarked]);

  const toggleBookmark = () => {
    window.dispatchEvent(new CustomEvent('propertyBookmark', { detail: { id: id } }));
  };

  return (
    <Button
      aria-label="Bookmark"
      className={buttonClass}
      icon={isBookmarked ? faBookmark : farBookmark}
      size={size}
      tooltip="Bookmark"
      tooltipPlacement="right"
      variant="ghost"
      onClick={toggleBookmark}
    />
  );
}
